import { MOBILE_BOTTOM_TOOLBAR_ID } from "@circle-react/components/constants";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { useIsMobileShellEnabled } from "@/react/components/Mobile/hooks/useIsMobileShellEnabled";

export interface ListWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const isMobileBottomToolbarVisible = () =>
  Boolean(document.getElementById(MOBILE_BOTTOM_TOOLBAR_ID));

export const ListWrapper = ({ children, className }: ListWrapperProps) => {
  const isMobileShellEnabled = useIsMobileShellEnabled();
  return (
    <div
      className={classNames(
        "w-full space-y-0.5 overflow-y-auto px-2 lg:h-[calc(100%-102px)]",
        {
          "h-[calc(100dvh-169px)]": !isMobileBottomToolbarVisible(),
          "h-[calc(100dvh-232px)]": isMobileBottomToolbarVisible(),
          "px-0": isMobileShellEnabled,
        },
        className,
      )}
      id="scrollable-dms-div"
    >
      {children}
    </div>
  );
};
